import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import './styles.scss';

import {
	goToNextStep,
	setTestStepAnswers,
	setIsSendingTestResultsToFalse,
} from 'actions/index';

import {TEST_STEPS} from 'constants/index';

import Intro from './Intro';
import Test from './Test';

const subSteps = [Intro, Test];

class Skrivehastighet extends React.Component {
	constructor() {
		super();

		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			currentSubstepIndex: 0,
		};
	}

	handleNextSubstep(results) {
		const {currentSubstepIndex} = this.state;

		const {
			onGoToNextStep,
			onSetTestStepAnswers,
			onSetIsSendingTestResultsToFalse,
		} = this.props;

		const isLastStep = currentSubstepIndex === subSteps.length - 1;

		if (isLastStep) {
			onSetTestStepAnswers(TEST_STEPS.SKRIVEHASTIGHET, results).then(
				() => {
					onSetIsSendingTestResultsToFalse();
					onGoToNextStep();
				}
			);
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;
		const {isNorming} = this.props;

		const CurrentSubStep = subSteps[currentSubstepIndex];

		return (
			<div className="lit-intro lit-skrivehastighet">
				<h1 className="lit-page-title">{strings.skrivehastighet}</h1>
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					isNorming={isNorming}
				/>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
	onSetIsSendingTestResultsToFalse: setIsSendingTestResultsToFalse,
};

export default connect(mapStateToProps, mapDispatchToProps)(Skrivehastighet);
